import { Component, Inject } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Coverage } from 'src/app/core/models/coverage .model';
import { Quotation } from 'src/app/core/models/product-info.model';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { LoaderService } from 'src/app/core/services/loader.service';
import { RestService } from 'src/app/core/services/rest.service';

@Component({
  selector: 'app-compare-premium',
  templateUrl: './compare-premium.component.html',
  styleUrls: ['./compare-premium.component.scss']
})
export class ComparePremiumComponent {
  productDetailes: Quotation[] = [];
  coveragesList: Coverage[] = [];
  coverageAmounts: any[] = [];
  coveragesList1: any[] = [];
  productDetailes1: any[] = [];

  constructor(
    public dialogRef: MatDialogRef<ComparePremiumComponent>,
    public loader: LoaderService,
    public fb: FormBuilder,
    private restService: RestService,
    public translate: TranslateService,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private errorHandler: ErrorHandlerService,
  ) {
  }

  ngOnInit() {
    this.QuotationCompare();
  }

  precomputeCoverageAmounts(data: any[]) {
    data.forEach(product => {
      product.coverageQuotesCompare.forEach((coverage: any) => {
        coverage.additionalData.forEach((ad: any) => {
          if (!this.coverageAmounts[coverage.CoverageID]) {
            this.coverageAmounts[coverage.CoverageID] = {};
          }
          if (!this.coverageAmounts[coverage.CoverageID][ad.id]) {
            this.coverageAmounts[coverage.CoverageID][ad.id] = {};
          }
          this.coverageAmounts[coverage.CoverageID][ad.id][product.ProductID] = ad.amount;
        });
      });
    });
  }

  getCoverageAmount(productID: string, coverageID: any, dataID: string): any {
    const coverage = this.coverageAmounts[coverageID];
    if (coverage) {
      const additionalData = coverage[dataID];
      if (additionalData && additionalData[productID]) {
        return additionalData[productID];
      }
    }
    return null;
  }

  QuotationCompare() {
    let params = {
      QuotationID: this.data.quotationId
    }
    this.loader.show();
    this.restService.postData(params, 'api/Quotation/QuotationCompare').subscribe(
      {
        next: (data: any) => {
          try {
            if (data.rcode == 200) {
              this.coveragesList1 = data.rObj.Coverages;
              this.productDetailes1 = data.rObj.QuotationCompare.map((item: any) => ({
                ProductID: item.ProductID,
                ProductName: item.ProductName,
                coverageQuotesCompare: item.coverageQuotesCompare.reduce((acc: any, coverage: any) => {
                  acc[coverage.CoverageID] = coverage.additionalData.reduce((adAcc: any, ad: any) => {
                    adAcc[ad.AdditionalCoverageID] = ad.AdditionalCoverageDescriptionUserLimit;
                    return adAcc;
                  }, {});
                  return acc;
                }, {})
              }));



            } else {
              this.errorHandler.handleRcodeError(data);
            }
          } catch (error) {
            this.errorHandler.internalError();
          } finally {
            this.loader.hide();
          }
        },
        error: (error: any) => {
          this.loader.hide();
          this.errorHandler.handleStatusError(error);
        }
      })
  }

  close() {
    this.dialogRef.close(true);
  }
}
